import { useQuery } from "@tanstack/react-query";
import { resolveVehicleImageUrl } from "@/utils/vehicleImageUtils";

const VEHICLE_IMAGE_STALE_TIME = 24 * 60 * 60 * 1000;

export function useVehicleImage(make?: string, model?: string) {
  const trimmedMake = make?.trim() ?? "";
  const trimmedModel = model?.trim() ?? "";

  return useQuery({
    queryKey: ["vehicle-image", trimmedMake, trimmedModel],
    queryFn: () => resolveVehicleImageUrl(trimmedMake, trimmedModel),
    enabled: Boolean(trimmedMake && trimmedModel),
    staleTime: VEHICLE_IMAGE_STALE_TIME,
    gcTime: VEHICLE_IMAGE_STALE_TIME,
    retry: false,
  });
}
